<select class="page-live-theme-select" (change)="onThemeSwitch($event)" title="Change theme" #themeSwitcher>
	<option value="light">Light theme</option>
	<option value="dark">Dark theme</option>
</select>